import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import SupplierInternalCommunicationService from 'src/modules/3rd-party-management/apis/admin/SupplierInternalCommunicationService';

export const SUPPLIER_OVERVIEW_COMMUNICATION_MENTION_SUGGESTIONS_QUERY_KEY = '3rd-party-management-fetch-internal-communication-mention-suggestion-list-query';

const useSupplierOverviewCommunicationMentionSuggestions = ({
    supplierId,
    t,
}) => {
    return useQuery({
        queryKey: [SUPPLIER_OVERVIEW_COMMUNICATION_MENTION_SUGGESTIONS_QUERY_KEY, supplierId],
        queryFn: async () => {
            const service = new SupplierInternalCommunicationService();

            return await service.mentionCommentSearch(supplierId, {
                query: '',
            });
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: !!supplierId,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching analyst admins list.'), {
                type: 'error',
            });
        },
    });
};

export default useSupplierOverviewCommunicationMentionSuggestions;
